import { Component, HostListener, OnInit } from '@angular/core';
import { BreadcrumbService } from '../../core/service/breadcrumb.service';

@Component({
  selector: 'app-sub-breadcrumb',
  templateUrl: './sub-breadcrumb.component.html',
  styleUrl: './sub-breadcrumb.component.css'
})
export class SubBreadcrumbComponent implements OnInit {
  steps: any[] = [];
  currentHeading: string = '';

  constructor(private breadcrumbService: BreadcrumbService) { }

  ngOnInit() {

    this.checkBreadcrumbs()

   

    // this.breadcrumbService.activeStepIndex$.subscribe((value:any)=>{
    //   console.log('line no 22 sub-bread');
    //   this.checkBreadcrumbs();
    // });
  }

  checkBreadcrumbs(){
     // Subscribe to steps and get the active index
     this.breadcrumbService.steps$.subscribe((steps) => {
      // this.currentStep = steps.findIndex((step) => step.active);
      this.steps = steps;
      console.log(this.steps,'line no 21');

      // Find the object with currentStep: true and extract the label
      const currentStepObject = steps.find((step) => step.currentStep === true);
      this.currentHeading = currentStepObject ? currentStepObject.label : null;
      console.log(this.currentHeading,'line no 37');

    });
  }


}
